import { NotificationInterface } from '@partnerconnect-monorepo/types/notification/Notification';
import { T } from '@transifex/react';
import { Loading, Text } from '@wfp/ui';
import './Notifications.scss';
import { Notification } from './Notification/Notification.connect';

interface NotificationsViewProps {
  reportingModuleNotifications: Array<NotificationInterface> | undefined;
  flaModuleNotifications: Array<NotificationInterface> | undefined;
  isLoading: boolean;
}

export const NotificationsView = ({
  reportingModuleNotifications,
  flaModuleNotifications,
  isLoading
}: NotificationsViewProps) => (
  <>
    <Text kind="h4">
      <T _str="Notifications" />
    </Text>
    {isLoading ? (
      <Loading withOverlay={false} small />
    ) : !reportingModuleNotifications?.length &&
      !flaModuleNotifications?.length ? (
      <Text kind="p">
        <T _str="No notifications to configure" />
      </Text>
    ) : (
      <>
        {!!reportingModuleNotifications?.length && (
          <>
            <Text kind="h5" className="mb-1">
              <T _str="Reporting" />
            </Text>
            <div className="notifications">
              {reportingModuleNotifications?.map(
                (notification, notificationIdx) => (
                  <Notification
                    key={`reporting-${notificationIdx}`}
                    notification={notification}
                    module="reporting"
                  />
                )
              )}
            </div>
          </>
        )}
        {!!flaModuleNotifications?.length && (
          <>
            <Text kind="h5" className="mb-1">
              <T _str="Partnerships" />
            </Text>
            <div className="notifications">
              {flaModuleNotifications?.map((notification, notificationIdx) => (
                <Notification
                  key={`fla-${notificationIdx}`}
                  notification={notification}
                  module="partnershipsAndFinances"
                />
              ))}
            </div>
          </>
        )}
      </>
    )}
  </>
);
